export const LANGUAGE_STORAGE_KEY = 'legal365.language';
export const DEFAULT_LANGUAGE = 'es-CL';

export const SHORT_TO_FULL_LANGUAGE = {
  es: 'es-CL',
  en: 'en-US',
  pt: 'pt-BR',
};

const SUPPORTED_LANGUAGES = new Set(Object.values(SHORT_TO_FULL_LANGUAGE));

export function normalizeLanguage(language) {
  if (!language) return DEFAULT_LANGUAGE;

  const normalized = `${language}`.trim().toLowerCase().replace('_', '-');
  if (SHORT_TO_FULL_LANGUAGE[normalized]) {
    return SHORT_TO_FULL_LANGUAGE[normalized];
  }

  const exactMatch = [...SUPPORTED_LANGUAGES].find(
    (value) => value.toLowerCase() === normalized
  );

  return exactMatch || DEFAULT_LANGUAGE;
}

export function toShortLanguage(language) {
  const normalized = normalizeLanguage(language);
  const entry = Object.entries(SHORT_TO_FULL_LANGUAGE).find(
    ([, full]) => full === normalized
  );

  return entry?.[0] || 'es';
}
